import request from '../utils/request';
import storage from '../utils/storage';
import conf from '../config/config';
import Vue from 'vue';

class DataStore {
    fetchData(options) {
        return new Promise((resolve, reject) => {
            this.fetchLocalData(options.url)
                .then(data => {
                    if(data && DataStore.expirationTimeVerification(data.cacheTime)){
                        resolve(data);
                    }else{
                        this.fetchNetData(options)
                            .then(res => {
                                if(res.resultCode == "00000000"){
                                    resolve(res);
                                }else{
                                    Vue.$vux.toast.show({
                                        type: 'text',
                                        text: res.resultDesc || '网络错误',
                                        time: 2000,
                                        width:"4rem"
                                    });
                                }
                            }, err => {
                                Vue.$vux.toast.show({
                                    type: 'text',
                                    text: err || '网络错误',
                                    time: 2000,
                                    width:"4rem"
                                });
                                reject(err);
                            })
                    }
                }, err => {
                    this.fetchNetData(options)
                        .then(res => {
                            resolve(res);
                        }, err => {
                            reject(err);
                        })
                });
        });
    }

    // 获取本地数据
    fetchLocalData(url) {
        return new Promise((resolve, reject) => {
            try {
                let data = JSON.parse(storage.getStorage(url));
                resolve(data);
            } catch(err) {
                reject(err);
            }
        });
    }

    // 获取网络数据
    fetchNetData(options) {
        Vue.$vux.loading.show({
            text:"加载中"
        });
        return new Promise((resolve, reject) => {
            request(options)
                .then(res => {
                    DataStore.saveData(options.url,res);
                    resolve(res);
                    Vue.$vux.loading.hide();
                }, err => {
                    reject(err);
                    Vue.$vux.loading.hide();
                });
        });
    }

    static saveData(url, data) {
        storage.setStorage(url,JSON.stringify(DataStore.wrapperData(data)))
    }

    static wrapperData(data){
        let cacheTime = (new Date).getTime();
        return {cacheTime,data};
    }

    static expirationTimeVerification(cacheTime){
        let currentTime = (new Date()).getTime();
        let expireHour = conf.expireHour;
        if((currentTime - cacheTime) > expireHour * 60 * 60 * 1000) return false;
        return true;
    }
}

export default DataStore;



// WEBPACK FOOTER //
// ./src/dao/DataStore.js